export default () => ({
	open: false,

	toggle() {
		this.open = ! this.open

		// Focus sur l'input après ouverture
		if (this.open) {
			this.$nextTick(() => {
				const searchInput = this.$refs.searchContainer.
				querySelector('input[type="search"]');
				console.log(this);
				console.log(searchInput);
				if (searchInput) {
					searchInput.focus()
					searchInput.addEventListener('blur', () => this.handleBlur())
				}
			})
		}
	},

	handleBlur() {
		// Petit délai pour permettre de cliquer sur des résultats de recherche si nécessaire
		setTimeout(() => {
			this.open = false
		}, 200)
	}
})
